// removed by extract-text-webpack-plugin
module.exports = {"field":"UserPage__field__3nmnQ","roles":"UserPage__roles__26k8d","role":"UserPage__role__3BVRm"};


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/dashboard/user/UserPage/UserPage.scss
// module id = 92
// module chunks = 0